import { SIZE } from 'common/constants';
import { TableOptions } from 'components/common/Table/Table';

export function getDefaultEndpointCardTableOptions(tabName: string): TableOptions {
  return {
    isStriped: true,
    isSortable: false,
    hoverRow: true,
    sidePadding: 10,
    autoSizeColumns: true,
    size: SIZE.SMALL,
    headerClass: `${tabName}__Header`,
    tableClass: `DV_${tabName}CellContent`,
    rowClass: `${tabName}__Row`,
  };
}

export const generalNetworkTableHeaders = [
  { content: 'Name', field: 'name', width: 160, className: 'General__Col General__Col__Name' },
  { content: 'Ip', field: 'gatewayIp', width: 100, className: 'General__Col General__Col__Version' },
  { content: 'Mac Address', field: 'gatewayMacAddress', width: 140, className: 'General__Col General__Col__Publisher' },
];

export enum EndpointTabs {
  general = 'General',
  cloud = 'Cloud',
  appInventory = 'App Inventory',
  tasks = 'Tasks',
  tags = 'Tags',
}

export enum TASK_TYPES {
  SCRIPT_EXECUTION = 'script_execution',
  AGENTS_UPGRADE = 'agents_upgrade',
  AUTO_DEPLOY = 'auto_deploy',
  CIS_SCAN = 'cis_scan',
  GAD = 'gad',
}

export const AGENT_NAME_BY_TASK_TYPE = {
  [TASK_TYPES.SCRIPT_EXECUTION]: {
    taskName: 'Remote Script',
  },
  [TASK_TYPES.AGENTS_UPGRADE]: {
    taskName: 'Agent Upgrade',
  },
  [TASK_TYPES.AUTO_DEPLOY]: {
    taskName: 'Ranger Deploy',
  },
  [TASK_TYPES.CIS_SCAN]: {
    taskName: 'Benchmarks',
  },
  [TASK_TYPES.GAD]: {
    taskName: 'Agent Content Updates',
  },
  emptyValue: {
    taskName: 'N/A',
  },
};

export const APPLICATION_TABLE_OPTIONS_NAME = 'Application';

export const TAGS_QUESTION_MARK_ICON = 'q-mark';

export const TASKS_EMPTY_STATE = 'No Tasks on this Endpoint';

export const APPLICATION_EMPTY_STATE = 'No Application Inventory \n on this Endpoint';
